import * as actionTypes from "../action-types";

const initialState = {
    rechargeServiceListData: [],
    isPrepaidRechargePlanOpen: false
};

const rechargeReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {

        case actionTypes.SET_RECHARGE_SERVICE_LIST:
            return { ...state, rechargeServiceListData: payload };

        default:
            return state;
    }
};

export default rechargeReducer;